import { render, staticRenderFns } from "./ExpensesNavigation.vue?vue&type=template&id=12c7128f&"
import script from "./ExpensesNavigation.vue?vue&type=script&lang=js&"
export * from "./ExpensesNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports